import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      &copy; {new Date().getFullYear()} by Bradford District Care NHS Foundation
      Trust
    </footer>
  );
};

export default Footer;
